import { useEffect, useState } from 'react';
import { canUseDOM } from './index';
export function useIsVisible(ref) {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(_ref => {
      let [entry] = _ref;
      if (canUseDOM) {
        setIntersecting(entry.isIntersecting);
      }
    });
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref]);
  return isIntersecting;
}